module.exports = __webpack_public_path__ + "img/body-2-lg.80396f22.png";